export default __webpack_public_path__ + "static/media/medium-park.4e6d216c.svg";